module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_2.56c30ed4.png";